import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import maxBy from 'lodash/maxBy'; 

import NetworksIconsBar from '../../common/networks-icons-bar/networks-icons-bar';
import menuItemsData from '../../../services/menu-items-data';
import articlesService from '../../../services/articles';
import newslettersService from '../../../services/newsletters';

import './footer.css';

const communityMenuItemsData = [ 
  {
    link: 'https://www.facebook.com/groups/angular2typescript',
    text: 'Facebook Group',
    icon: 'fa-facebook-square'
  },
  {
    link: 'https://www.linkedin.com/groups/7053365',
    text: 'Linkedin Group',
    icon: 'fa-linkedin-square'
  }, 
];

class Footer extends Component {
    constructor(props) {
      super(props);

      this.state = {
        newestArticleLinkId: null,
        newestNewsletterId: null,
        currentYear: (new Date()).getFullYear(),
      };
  }

  componentDidMount() {
    articlesService.getArticlesSummaries()
      .then((articles) => {
        this.setState({
          newestArticleLinkId: this._getNewestArticleLinkId(articles)
        });          
      })
      .catch((error) => {
        
      });

    newslettersService.getNewsletters()
      .then((newsletters) => {
        this.setState({
          newestNewsletterId: this._getNewestNewsletterId(newsletters)
        });        
      })
      .catch((error) => {
        
      });      
  }

  _getNewestNewsletterId(items) {
    if (!items || items.length === 0) {
      return null;
    }

    return maxBy(items, (item) => Number(item._id))._id;
  }

  _getNewestArticleLinkId(items) {
    if (!items || items.length === 0) {
      return null;
    }

    return maxBy(items, (item) => Number(item._id)).linkId;
  }
  
  render() {
    let shortcutsMenuJSX = '';
    if (this.state.newestArticleLinkId && this.state.newestNewsletterId) {
      shortcutsMenuJSX = (
        <div>
          <div className='title'>Community</div>
          <nav>
            <Link to={`/articles/${this.state.newestArticleLinkId}`} title='Newest Article'>
              {/*<i className='fa fa-file-text' aria-hidden="true"></i>              */}
              Newest Article
            </Link>
            <Link to={`/newsletters/${this.state.newestNewsletterId}`} title='Newest Newsletter'>
              {/*<i className='fa fa-newspaper-o' aria-hidden="true"></i>                          */}
              Newest Newsletter
            </Link>
          </nav>
        </div>
      );
    }

    return (
      <footer>
        <div className='footer-content'>      
          <div className='footer-area left-area'>
            <nav>
              {
                menuItemsData.map((itemData) => 
                  <Link to={itemData.link} key={itemData.text}>
                    {/*<i className={`fa ${itemData.icon}`} aria-hidden="true"></i>*/}
                    {itemData.text}
                  </Link>
                )
              }
            </nav>
          </div>

          <div className='footer-area middle-area'>
            <div>
              <div className='title'>Shortcuts</div>
              <nav>
                {
                  communityMenuItemsData.map((itemData) => 
                    <a href={itemData.link} 
                       key={itemData.text}
                       title={itemData.text}
                       target='_blank'>

                        {/*<i className={`fa ${itemData.icon}`} aria-hidden="true"></i>              */}
                        {itemData.text}
                    </a>
                  )
                }
              </nav>
            </div>

            {shortcutsMenuJSX}
          </div>      

          <div className='footer-area right-area'>
            <div className='networks-icons-bar'>
              <div className='title'>Get Connected!</div>          
              <NetworksIconsBar />
            </div>

            <span className='all-rights'>
              © { this.state.currentYear } by Dor Moshe
            </span>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;